import { ExternalResourceRenderer } from '../ExternalResourceRenderer/ExternalResourceRenderer'
import cx from 'classnames'
import Styles from '../../ProseEdit.module.scss'
import { ArticleFlat } from 'types'

interface Props {
  isRightNavOpen?: boolean
  article: ArticleFlat
}

export const ExternalResourceReader = ({ isRightNavOpen = false, article }: Props) => (
  <>
    <ExternalResourceRenderer
      article={article}
      customClass={cx(Styles.rightRailExternalResource, {
        [Styles.rightRailClosed]: !isRightNavOpen,
      })}
    />
  </>
)
